import { useState } from 'react'
import { useDispatch } from 'react-redux'
import { clearClubState, findMember } from '../state/clubSlice'
import { Box, Button, TextField } from '@material-ui/core'
import { useHistory } from 'react-router'

interface MemberFinderProps {}

const MemberFinder: React.FC<MemberFinderProps> = () => {
  const dispatch = useDispatch()
  const [searchKey, setSearchKey] = useState('')
  const history = useHistory()

  const handleFindMember = () => {
    dispatch(findMember(searchKey))
  }
  const handleChangeUser = (value: string) => {
    setSearchKey(value)
  }
  const handleClearMember = () => {
    setSearchKey('')
    dispatch(clearClubState())
    window.location.reload()
  }

  const handleRedirect = () => {
    history.push('signup/miembro')
  }

  return (
    <div>
      <Box display="flex" flexDirection="column">
        <Box display="flex" flexDirection="row" alignItems="center">
          <h4>Busca un miembro de tu club:</h4>
          <TextField
            style={{
              marginLeft: '1em',
              borderColor: '#ffdda5'
            }}
            value={searchKey}
            size="small"
            onChange={event => handleChangeUser(event.target.value)}
            variant="outlined"
          />
          <Button
            style={{
              marginLeft: '1em'
            }}
            variant="contained"
            color="primary"
            disabled={searchKey.trim().length <= 3}
            onClick={event => {
              event.preventDefault()
              handleFindMember()
            }}
          >
            Buscar
          </Button>
          <Button
            style={{
              marginLeft: '1em'
            }}
            variant="contained"
            color="primary"
            disabled={searchKey.length <= 0}
            onClick={event => {
              event.preventDefault()
              handleClearMember()
            }}
          >
            Borrar
          </Button>
        </Box>
        <Box display="flex" flexDirection="row" alignItems="center" justifyContent="end">
          <Button variant="contained" color="primary" onClick={() => handleRedirect()}>
            Agregar referenciador
          </Button>
        </Box>
      </Box>
    </div>
  )
}

export default MemberFinder
